export const REPEATING_BOOKINGS_HARD_LIMIT = 30

export const REPEAT_TYPES = {
  GROUP: 'G',
  EVERY_DAY: 'D',
  EVERY_WEEK: 'W',
  EVERY_TWO_WEEKS: 'F',
  EVERY_THREE_WEEKS: 'T',
  EVERY_FOUR_WEEKS: 'H',
  EVERY_SIX_WEEKS: 'S',
  EVERY_MONTH: 'M',
  CUSTOM: 'C',
} as const

export type RepeatType = (typeof REPEAT_TYPES)[keyof typeof REPEAT_TYPES]

export const REPEAT_TYPES_T_KEYS: {
  [K in Exclude<RepeatType, typeof REPEAT_TYPES.GROUP>]: string
} = {
  [REPEAT_TYPES.EVERY_DAY]: 'components.repeating.repeat.every-day',
  [REPEAT_TYPES.EVERY_WEEK]: 'components.repeating.repeat.every-week',
  [REPEAT_TYPES.EVERY_TWO_WEEKS]: 'components.repeating.repeat.every-two-weeks',
  [REPEAT_TYPES.EVERY_THREE_WEEKS]: 'components.repeating.repeat.every-three-weeks',
  [REPEAT_TYPES.EVERY_FOUR_WEEKS]: 'components.repeating.repeat.every-four-weeks',
  [REPEAT_TYPES.EVERY_SIX_WEEKS]: 'components.repeating.repeat.every-six-weeks',
  [REPEAT_TYPES.EVERY_MONTH]: 'components.repeating.repeat.every-month',
  [REPEAT_TYPES.CUSTOM]: 'components.repeating.repeat.custom',
}

export const END_TYPES = {
  NEVER: 'N',
  ON_DATE: 'D',
  AFTER_N_BOOKINGS: 'A',
} as const

export type EndType = (typeof END_TYPES)[keyof typeof END_TYPES]

export const END_TYPES_T_KEYS: Record<EndType, string> = {
  [END_TYPES.NEVER]: 'components.repeating.end-type.never',
  [END_TYPES.ON_DATE]: 'components.repeating.end-type.on-date',
  [END_TYPES.AFTER_N_BOOKINGS]: 'components.repeating.end-type.after-n-bookings',
}

export interface RepeatingBookingFormModel {
  repeat: RepeatType | null
  end_type: EndType | null
  repeat_till: string | null
  repeat_number: number
  has_child: boolean
  booking_dates: unknown[]
}

export const DEFAULT_MODEL: RepeatingBookingFormModel = {
  repeat: null,
  end_type: null,
  repeat_till: null,
  repeat_number: 2,
  has_child: false,
  booking_dates: [],
}

export const DEFAULT_GROUP_MODEL: RepeatingBookingFormModel = {
  ...DEFAULT_MODEL,
  repeat: REPEAT_TYPES.GROUP,
  end_type: END_TYPES.AFTER_N_BOOKINGS,
}

export const REPEATING_MODE = {
  GROUP_BOOKING: 'GROUP_BOOKING',
  RECURRING: 'RECURRING',
} as const

export type RepeatingMode = (typeof REPEATING_MODE)[keyof typeof REPEATING_MODE]

export const GROUP_BOOKING_MIN_GROUP_SIZE = 2
export const GROUP_BOOKING_MAX_GROUP_SIZE = 10

export const REPEATING_UPDATE_FUTURE_ACTION = {
  CANCEL: 'cancel',
  UPDATE: 'update',
} as const

export type RepeatingUpdateFutureAction =
  (typeof REPEATING_UPDATE_FUTURE_ACTION)[keyof typeof REPEATING_UPDATE_FUTURE_ACTION]
